module.exports = __webpack_public_path__ + "static/gradient_5-46261031e9fa7ad85cc941806a46d525.png";